import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">HashFusion Innovations</h3>
            <p className="footer-description">
              Building health-focused innovations for humans.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#who-we-are">Who We Are</a></li>
              <li><a href="#our-vision">Our Vision</a></li>
              <li><a href="#what-we-do">What We Do</a></li>
              <li><a href="#how-we-think">How We Think</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><a href="#ventures">Ventures</a></li>
              <li><a href="#founders">The Founders</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><a href="#careers">Careers</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Connect</h4>
            <div className="social-links">
              <a href="#linkedin" className="social-icon">LinkedIn</a>
              <a href="#twitter" className="social-icon">Twitter</a>
              <a href="#github" className="social-icon">GitHub</a>
              <a href="#medium" className="social-icon">Medium</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 HashFusion Innovations. All rights reserved.</p>
          <div className="footer-legal">
            <a href="#privacy">Privacy Policy</a>
            <span>|</span>
            <a href="#terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
